module.exports = __webpack_public_path__ + "img/version_plate.a3044fbc.svg";